/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RunEventDTO
 */
export interface RunEventDTO {
  /**
   *
   * @type {number}
   * @memberof RunEventDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof RunEventDTO
   */
  action: RunEventDTOActionEnum;
  /**
   * The affected product. A historical reference — the page may since have been deleted.
   * @type {number}
   * @memberof RunEventDTO
   */
  productId?: number | null;
  /**
   *
   * @type {string}
   * @memberof RunEventDTO
   */
  ean?: string | null;
  /**
   * The affected page's slug at the time of the event — the durable record of which page a DELETE removed.
   * @type {string}
   * @memberof RunEventDTO
   */
  slug?: string | null;
  /**
   * Set only on ERROR events.
   * @type {string}
   * @memberof RunEventDTO
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof RunEventDTO
   */
  createdAt: string;
}

/**
 * @export
 */
export const RunEventDTOActionEnum = {
  SET_ONLINE: "SET_ONLINE",
  SET_OFFLINE: "SET_OFFLINE",
  START_GRACE: "START_GRACE",
  RESET_GRACE: "RESET_GRACE",
  CREATE: "CREATE",
  DELETE: "DELETE",
  ERROR: "ERROR",
  RECONCILE: "RECONCILE"
} as const;
export type RunEventDTOActionEnum = typeof RunEventDTOActionEnum[keyof typeof RunEventDTOActionEnum];

/**
 * Check if a given object implements the RunEventDTO interface.
 */
export function instanceOfRunEventDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "action" in value;
  isInstance = isInstance && "createdAt" in value;

  return isInstance;
}

export function RunEventDTOFromJSON(json: any): RunEventDTO {
  return RunEventDTOFromJSONTyped(json, false);
}

export function RunEventDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunEventDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    action: json["action"],
    productId: !exists(json, "productId") ? undefined : json["productId"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    slug: !exists(json, "slug") ? undefined : json["slug"],
    message: !exists(json, "message") ? undefined : json["message"],
    createdAt: json["createdAt"]
  };
}

export function RunEventDTOToJSON(value?: RunEventDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    action: value.action,
    productId: value.productId,
    ean: value.ean,
    slug: value.slug,
    message: value.message,
    createdAt: value.createdAt
  };
}
